import React from 'react';

import { Alert } from '@components/common/Alert';

export const GQSurveyPreviewSuccessPage = ({
  hasQualificationRules,
  onPreviewConfirmationTypeChange,
  previewConfirmationType
}: {
  hasQualificationRules: boolean;
  onPreviewConfirmationTypeChange: (type: string) => void;
  previewConfirmationType: string;
}) => {
  if (!hasQualificationRules) {
    return (
      <Alert heading='You are previewing the confirmation page for a manual review or non-ideal candidate submission.'>
        Automatic review for a successful ideal participant will take the participant to the test.
      </Alert>
    );
  }

  return (
    <div className='relative z-10 mb-6'>
      <Alert heading='You are previewing the confirmation page. Use the buttons below to simulate different confirmation types:'>
        <div className='mt-4 flex flex-wrap gap-2'>
          <button
            onClick={() => onPreviewConfirmationTypeChange('auto_qualified')}
            className={`rounded px-3 py-1 text-xs ${
              previewConfirmationType === 'auto_qualified'
                ? 'bg-green-600 text-white'
                : 'border border-green-300 bg-white text-green-700 hover:bg-green-50'
            }`}
          >
            Auto Qualified
          </button>
          <button
            onClick={() => onPreviewConfirmationTypeChange('auto_disqualified')}
            className={`rounded px-3 py-1 text-xs ${
              previewConfirmationType === 'auto_disqualified'
                ? 'bg-red-600 text-white'
                : 'border border-red-300 bg-white text-red-700 hover:bg-red-50'
            }`}
          >
            Auto Disqualified
          </button>
          <button
            onClick={() => onPreviewConfirmationTypeChange('manual_review')}
            className={`rounded px-3 py-1 text-xs ${
              previewConfirmationType === 'manual_review'
                ? 'bg-yellow-600 text-white'
                : 'border border-yellow-300 bg-white text-yellow-700 hover:bg-yellow-50'
            }`}
          >
            Manual Review
          </button>
        </div>
      </Alert>
    </div>
  );
};
